import { call, put, select, take, takeLatest } from 'redux-saga/effects';
import { ADD_SERVICE, REMOVE_SERVICE, SAVE_SERVICES, SET_SERVICE, DELETE_ALL_TYPES_ON_SEGMENT, SET_MULTIPLE_SELECTED_SERVICES } from './actions';
import { createClient } from '../../../graphql-client';
import { getSelectedServices, getSelectedServicesTypes } from './selectors';
import { getIsBookedOrConfirmed, getOrderId, getOrder } from '../order/selectors';
import { ApolloError } from 'apollo-boost';
import { fillOrder } from '../order/actions';
import { setOrderPrice } from '../orderPrice/actions';
import { setLoadingServicesParams, clearLoadingServicesParams } from '../loadingServicesParams/actions';
import { setServicesIsSaving, setServicesSaved } from '../servicesIsSaving/actions';
import { getEveryPortSelectedServicesArray } from '../everyPortServices/selectors';
import { SET_EVERY_PORT_ACTION } from '../everyPortServices/actions';
import { OrderDocument, SaveOrderServicesDocument, OrderPriceQueryDocument } from '@websky/graphql';
import { createExternalSagaActionChannel } from '../../../utils';
export const CHECKOUT_EXTERNAL_ACTION = 'CHECKOUT_EXTERNAL_ACTION';
const SHOW_ERROR_MODAL_ERRORS = ['FAILED TO CREATE AN ORDER'];
import { SET_EVERY_TRAVEL_CART } from '../everyTravel/actions';
import { getEveryTravelService } from '../everyTravel/selectors';
import { setErrorMessage } from '../errorMessage/actions';
function priceBreakdownRequest(services, everyPortServices, everyTravel, orderId) {
    var _a, _b;
    const client = createClient();
    return client.mutate({
        mutation: OrderPriceQueryDocument,
        variables: {
            params: {
                id: orderId,
                services: services,
                nas: {
                    services: [...everyPortServices]
                },
                everyTravel: {
                    cartId: (_b = (_a = everyTravel.cartId) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : null
                }
            }
        }
    });
}
function saveSelectedServicesRequest(services, everyPortServices, everyTravel, orderId, context) {
    var _a, _b;
    const client = createClient();
    return client.mutate({
        mutation: SaveOrderServicesDocument,
        variables: {
            params: {
                id: orderId,
                services: services,
                nas: {
                    services: [...everyPortServices]
                },
                everyTravel: {
                    cartId: (_b = (_a = everyTravel.cartId) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : null
                }
            }
        },
        context
    });
}
function actualOrderRequest(orderId) {
    const client = createClient();
    return new Promise(resolve => {
        client
            .mutate({
            mutation: OrderDocument,
            variables: {
                id: orderId
            }
        })
            .then(response => {
            var _a;
            if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.Order) {
                resolve(response.data.Order);
            }
            else {
                resolve(null);
            }
        })
            .catch(() => {
            resolve(null);
        });
    });
}
function* getActualOrder(orderId) {
    const actualOrder = yield call(actualOrderRequest, orderId);
    if (actualOrder) {
        return actualOrder;
    }
    const previousOrderState = yield select(getOrder);
    return previousOrderState;
}
function* saveServiceWorker(action) {
    var _a, _b, _c, _d, _e, _f;
    const selectedServices = yield select(getSelectedServices), everyPortSelectedServices = yield select(getEveryPortSelectedServicesArray), everyTravelServices = yield select(getEveryTravelService), orderId = yield select(getOrderId), isBookedOrConfirmedOrder = yield select(getIsBookedOrConfirmed), selectedServicesTypes = yield select(getSelectedServicesTypes(action.payload));
    yield put(setServicesIsSaving());
    yield put(setLoadingServicesParams(selectedServicesTypes));
    try {
        if (!isBookedOrConfirmedOrder) {
            const orderPrice = yield call(priceBreakdownRequest, selectedServices, everyPortSelectedServices, everyTravelServices, orderId);
            if (!((_a = orderPrice.data) === null || _a === void 0 ? void 0 : _a.OrderPrice) || ((_b = orderPrice.errors) === null || _b === void 0 ? void 0 : _b.length)) {
                throw new Error((_c = orderPrice.errors[0]) === null || _c === void 0 ? void 0 : _c.message);
            }
            yield put(setOrderPrice(orderPrice.data.OrderPrice));
        }
        const saveServices = yield call(saveSelectedServicesRequest, selectedServices, everyPortSelectedServices, everyTravelServices, orderId, action.meta);
        if (!((_d = saveServices.data) === null || _d === void 0 ? void 0 : _d.SaveOrderServices) || ((_e = saveServices.errors) === null || _e === void 0 ? void 0 : _e.length)) {
            throw new Error((_f = saveServices.errors[0]) === null || _f === void 0 ? void 0 : _f.message);
        }
        yield put(fillOrder(saveServices.data.SaveOrderServices));
    }
    catch (error) {
        let errorMessage = 'Unknown error';
        if (error instanceof ApolloError || error instanceof Error) {
            errorMessage = error.message;
        }
        const actualOrder = yield call(getActualOrder, orderId);
        yield put(fillOrder(actualOrder));
        if (SHOW_ERROR_MODAL_ERRORS.some(err => errorMessage.includes(err))) {
            yield put(setErrorMessage(errorMessage));
        }
    }
    yield put(setServicesSaved());
    yield put(clearLoadingServicesParams());
}
export function* saveServicesSaga() {
    yield takeLatest([
        ADD_SERVICE,
        REMOVE_SERVICE,
        SAVE_SERVICES,
        SET_SERVICE,
        DELETE_ALL_TYPES_ON_SEGMENT,
        SET_MULTIPLE_SELECTED_SERVICES,
        SET_EVERY_PORT_ACTION,
        SET_EVERY_TRAVEL_CART
    ], saveServiceWorker);
}
function* externalSaga() {
    const channel = yield createExternalSagaActionChannel(CHECKOUT_EXTERNAL_ACTION);
    while (true) {
        const action = yield take(channel);
        yield put(action);
    }
}
export function* watchExternalActionsSaga() {
    yield externalSaga();
}
